import React from 'react'
import { AppButtonIcon, AppRetailerBlock } from '@components'
import { Box } from '@mui/material'

export default function websiteColumn() {
	return {
		name: "id_site_translation",
		label: "Website",
		options: {
			setCellProps: () => ({ sx: { minWidth: "200px" } }),
			customBodyRowRenderLite: (value, { siteMarket, siteIco, search_url, screenshot }) => {
				return (
					<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
						<AppRetailerBlock retailer={value} icon={siteIco} country={siteMarket} />
						<ButtonComponent icon="up-right-from-square" tooltip="Link to Website" url={search_url} color="colors.blue" />
						<ButtonComponent icon="image" tooltip="Screenshot" url={screenshot} color="colors.green" />
					</Box>
				)
			},
		},
	}
}

function ButtonComponent({ icon, tooltip, url, color }) {
	if(!url) return null

	return <AppButtonIcon
		iconProps={{ sx: { color } }}
		icon={icon}
		tooltip={tooltip}
		onClick={(e) => {
			window.open(url, "_blank")
			if (e.ctrlKey) e.preventDefault()
		}}
		onAuxClick={(e) => {
			if (e.button === 1) {
				window.open(url)
				e.preventDefault()
			}
		}}
	/>
}
